'use client'

import { useId } from 'react'
import { createContext } from '../../utils'

type TabType = 'simple' | 'bubble'

type useTabsProps<TId extends string> = {
  current: string
  id?: string
  type: TabType
  onClick: (id: TId) => void
}

function useTabs<TId extends string>({
  current,
  id: idProp,
  type,
  onClick,
}: useTabsProps<TId>) {
  const uuid = useId()
  const id = idProp ?? uuid

  return {
    current,
    id,
    type,
    onClick,
  }
}

type UseTabsReturn = ReturnType<typeof useTabs>

const [TabsProvider, useTabsContext] = createContext<UseTabsReturn>({
  name: 'TabsProvider',
})

export {
  TabsProvider,
  useTabs,
  useTabsContext,
  type useTabsProps,
  type TabType,
}
